skrilla.service('racingEventService', function (envService) {

    let isRacingEvent = function (eventType) {
        return eventType && eventType === 'RACE'
    }

    let getV2Url = function (path, entityId) {
        return `${envService.read("v2Url")}/${path}/${entityId}`
    }

    return {
        isRacingEvent,
        getV2Url,
    };
});

